<template>
  <jump-to-nav
    class="laptop:position-sticky-top laptop:padding-top-2xl"
    title="On This Page"
  >
    <list has-divider>
      <list-item hash="#about">What is Font Awesome?</list-item>
      <list-item hash="#collection">How does Font Awesome collect data about me?</list-item>
      <list-item hash="#data">What data does Font Awesome collect about me, and why?</list-item>
      <list-item hash="#choice">How can I make choices about data collection?</list-item>
      <list-item hash="#locality">Where does Font Awesome store data about me?</list-item>
      <list-item hash="#gdpr">Does Font Awesome comply with the EU General Data Protection Regulation?</list-item>
      <list-item hash="#access">Where can I see, change, and erase data about me?</list-item>
      <list-item
        hash="#sharing"
        is-last
      >
        Does Font Awesome share data about me with others?
      </list-item>
    </list>

    <list has-divider>
      <list-item hash="#contact">How can I contact Font Awesome about privacy?</list-item>
      <list-item
        hash="#changes"
        is-last
      >
        How can I find out about changes?
      </list-item>
    </list>

    <list has-divider>
      <list-item hash="#cdn-providers">Content Delivery Network Providers</list-item>
      <list-item hash="#payment-processors">Payment Processors</list-item>
      <list-item
        hash="#other-services"
        is-last
      >
        Other Services
      </list-item>
    </list>

    <list>
      <list-item hash="#dpf-details">EU-U.S. Data Protection Framework Statement and Policy</list-item>
    </list>
  </jump-to-nav>
</template>
<script>
  import JumpToNav from 'app/components-wa/nav/JumpToNav'
  import JumpToNavList from 'app/components-wa/nav/JumpToNavList'
  import JumpToNavListItem from 'app/components-wa/nav/JumpToNavListItem'

  export default {
    name: 'InPageNav',

    components: {
      JumpToNav,
      List: JumpToNavList,
      ListItem: JumpToNavListItem
    }
  }
</script>
